import { useEffect, useState } from 'react';

export function useAnalyticsSection<T>(loader: () => Promise<T | null>, empty: T) {
  const [data, setData] = useState<T>(empty);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void loader().then((res) => {
      if (!cancelled) {
        setData(res ?? empty);
        setLoading(false);
      }
    });
    return () => {
      cancelled = true;
    };
    // empty is a stable module-level constant in callers
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loader]);

  return { data, loading };
}
